import WeaInputLocale from "./component/weaInputLocale";
import middleware from "../../middleware";

const Com = middleware(WeaInputLocale, "WeaInputLocale");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-input-locale/index.js